export const gallerySectionBalconyRenewal =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/5.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/6.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/7.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/8.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/9.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/10.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/11.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/12.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/13.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/14.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/15.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/16.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/17.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/18.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/19.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/20.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/21.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/22.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/23.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/24.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/25.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/26.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/27.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/28.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/29.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/30.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/31.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/32.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/33.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/34.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/35.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/36.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/37.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/38.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/39.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/40.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/41.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/42.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/43.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/44.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/45.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/46.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/47.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/48.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/49.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/50.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/51.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/52.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/53.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/54.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0009BalconyRenewals/55.jpg",
            "rowSpan": 2,
            "colSpan": 2
        }
    ]
}